import http from '@/modules/http.js'

const state = {
  token: localStorage.getItem('jwt')
}

const getters = {
  IS_LOGIN: state => !!state.token,
  GET_TOKEN: state => state.token
}

const actions = {
  AUTH_REQUEST(context, user) {
    return new Promise((resolve, reject) => {
      const authUrl = http.defaults.baseURL.replace('api/', 'authentication')
      http
        .post(authUrl, {
          strategy: 'local',
          login: user.username,
          password: user.password
        })
        .then(response => response.data.accessToken)
        .then(token => {
          localStorage.setItem('jwt', token)
          http.defaults.headers.common['Authorization'] = token
          context.commit('AUTH_SUCCESS', token)
        })
        .then(() => resolve())
        .catch(error => {
          localStorage.removeItem('jwt')
          reject(error)
        })
    })
  },
  AUTH_LOGOUT({ commit, dispatch }) {
    return new Promise(resolve => {
      commit('AUTH_LOGOUT')
      dispatch('RESET_AUTH_DATA')
      dispatch('RESET_HOSPITAL')
      localStorage.removeItem('jwt')
      delete http.defaults.headers.common['Authorization']
      resolve()
    })
  },
  RESET_AUTH_DATA({ commit }) {
    commit('CLEAR_AUTH_USER')
    commit('RESET_SOCKET_AUTH')
    commit('RESET_SELECTED_HOSPITAL')
  },
  SEND_EMAIL(context, login) {
    return new Promise((resolve, reject) => {
      http
        .get(`/emails?login=${login}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  SEND_EMAIL_WITH_RESET_PASSWORD(context, self) {
    let params = {
      login: self.username,
      url: window.location.protocol + '//' + window.location.host + '/registration/',
      subject: self.$t('messageEmail.titleForPasswordChange'),
      text: self.$t('messageEmail.bodyForPasswordChange')
    }
    return new Promise((resolve, reject) => {
      http
        .get(`/reset-password`, {
          params: params
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  RESET_PASSWORD(context, userId) {
    return new Promise((resolve, reject) => {
      http
        .patch(`/reset-password?userId=${userId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
  AUTH_SUCCESS(state, token) {
    state.token = token
  },
  AUTH_LOGOUT(state) {
    state.token = null
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
